export function encurtarNome(nome) {
  if (!nome) return "";

  const excecoes = new Set([
    "a",
    "o",
    "as",
    "os",
    "de",
    "dos",
    "das",
    "do",
    "da",
    "e",
    "ou",
    "para",
    "por",
    "no",
    "na",
    "nos",
    "nas",
  ]);

  const palavras = nome.toLowerCase().split(" ");

  // Filtrar preposições e pegar os 2 primeiros nomes válidos
  const nomesValidos = palavras.filter((palavra) => !excecoes.has(palavra));

  // Pegar apenas os 2 primeiros nomes válidos
  const nomeAbreviado = nomesValidos
    .slice(0, 2)
    .map((palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1))
    .join(" ");

  return nomeAbreviado;
}
